import { createFileRoute, redirect } from '@tanstack/react-router';
import usePhysiomKineStore from '@/stores/physiomKine';
import { meQueryOptions } from '@/hooks/me.hook';
export const Route = createFileRoute('/_private')({
  beforeLoad: async ({ context }) => {
    const { isAuthenticated } = context;

    if (!isAuthenticated) {
      throw redirect({ to: '/auth/login' });
    }

    const user = await context.queryClient.fetchQuery(meQueryOptions);

    if (user) {
      const { login } = usePhysiomKineStore.getState();

      login(user);
    }
  },
});
